import { createQueryKeys } from '@lukemorales/query-key-factory';

export const role = createQueryKeys('role', {
    information: {
        queryKey: null,
    },
});
